import { FgPriceListCategoryEnum } from "@gtpl/shared-models/masters"
import { OrderTypeEnum, StyleWeighmentEnum } from "../enum"

export class EnquiryProductModel{
    productId:number
    enquiryId:number
    category:FgPriceListCategoryEnum
    brandId:number
    brandName: string
    variantId:number
    variantName: string
    shortCode:string
    packStyleId:number
    packStyleName: string
    uomId: number
    uomName: string
    styleWeighment:StyleWeighmentEnum
    unitPrice:number
    noOfCases:number
    caseWeight:number
    netWeight:number
    netAmount:number
    noOfSkewers:number//for skewer category
    varietyId:number//size for rings and skewers
    varietyName: string
    shrimpWeight: number
    // orderType: OrderTypeEnum
    packCount: number
    packMaterialCost:number
    grouping:number
    noOfContainers:number
    sizeName:string
    orderType?:OrderTypeEnum
    brandType?:string
    uvPriceCategory?:string
    uvType?:string
    uvPercentOrCent?:string
    pouches?:number
    pouchePerRow?:number
    priceBasedOn?:string
    constructor(
        productId:number,
        enquiryId:number,
        category:FgPriceListCategoryEnum,
        brandId:number,
        brandName: string,
        variantId:number,
        variantName: string,
        shortCode:string,
        packStyleId:number,
        packStyleName: string,
        uomId: number,
        uomName: string,
        styleWeighment:StyleWeighmentEnum,
        unitPrice:number,
        noOfCases:number,
        caseWeight:number,
        netWeight:number,
        netAmount:number,
        noOfSkewers:number,//for skewer category
        varietyId:number,//size for rings and skewers
        varietyName: string,
        shrimpWeight: number,
        // orderType: OrderTypeEnum,
        packCount: number,
        packMaterialCost:number,
        grouping:number,
        noOfContainers:number,
        sizeName:string,
        orderType?:OrderTypeEnum,
        brandType?:string,
        uvPriceCategory?:string,
        uvType?:string,
        uvPercentOrCent?:string,
        pouches?:number,
        pouchePerRow?:number,
        priceBasedOn?:string
    ){
        this.productId=productId
        this.enquiryId=enquiryId
        this.category=category
        this.brandId=brandId
        this.variantId=variantId
        this.packStyleId=packStyleId
        this.styleWeighment=styleWeighment
        this.unitPrice=unitPrice
        this.noOfCases=noOfCases
        this.caseWeight=caseWeight
        this.netWeight=netWeight
        this.netAmount=netAmount
        this.noOfSkewers=noOfSkewers
        this.varietyId=varietyId
        this.brandName = brandName
        this.variantName = variantName
        this.shortCode=shortCode
        this.varietyName = varietyName
        this.packStyleName = packStyleName
        this.uomId = uomId
        this.uomName = uomName
        this.shrimpWeight = shrimpWeight
        // this.orderType = orderType
        this.packCount = packCount
        this.packMaterialCost = packMaterialCost
        this.grouping = grouping
        this.noOfContainers = noOfContainers
        this.sizeName=sizeName
        this.orderType = orderType
        this.brandType = brandType
        this.uvPriceCategory = uvPriceCategory
        this.uvType = uvType
        this.uvPercentOrCent = uvPercentOrCent
        this.pouches = pouches
        this.pouchePerRow = pouchePerRow
        this.priceBasedOn = priceBasedOn
        }
}